import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Heart, Copy, Check } from 'lucide-react';

export const DonationModal = ({ isOpen, onClose }) => {
  const [copied, setCopied] = useState(null);

  const bankDetails = {
    accountName: 'Ximdrake Asidor',
    accountNumber: '0059001677',
    bankName: 'Bank of the Philippine Islands (BPI)',
    swiftCode: 'BOPIPHMM',
    routingNumber: '010040018'
  };

  const handleCopy = (text, field) => {
    navigator.clipboard.writeText(text);
    setCopied(field);
    setTimeout(() => setCopied(null), 2000);
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="rounded-xl shadow-2xl p-6 md:p-8 max-w-2xl w-full max-h-[85vh] overflow-y-auto border border-white/20 backdrop-blur"
            initial={{ scale: 0.9, y: 20 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.9, y: 20 }}
            onClick={e => e.stopPropagation()}
          >
            {/* Header */}
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-white flex items-center gap-2">
                  <Heart size={28} className="text-red-400" /> Make a Donation
                </h2>
                <p className="text-white/80 text-sm mt-1">Support The AsidorS ministry and our mission</p>
              </div>
              <button
                onClick={onClose}
                className="p-2 hover:bg-white/10 rounded-lg transition"
              >
                <X size={24} className="text-white/80" />
              </button>
            </div>

            <div className="space-y-4">
              {/* GCash QR Section */}
              {/* <div className="bg-white/10 backdrop-blur-md rounded-xl md:rounded-2xl p-4 md:p-6 border border-white/20 transition-all overflow-hidden">
                <h3 className="font-bold text-white mb-3 text-center text-lg">GCash</h3>
                <div className="bg-white/5 rounded-lg p-3 flex items-center justify-center border border-white/10">
                  <img
                    src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://gcash.com/donate"
                    alt="GCash QR Code"
                    className="w-40 h-40"
                  />
                </div>
                <p className="text-xs text-white/70 text-center mt-3">Scan to donate via GCash</p>
              </div> */}

              {/* Bank QR Section */}
              <div className="bg-white/10 backdrop-blur-md rounded-xl md:rounded-2xl p-4 md:p-6 border border-white/20 transition-all overflow-hidden">
                <h3 className="font-bold text-white mb-3 text-center text-lg">Bank Transfer</h3>
                <div className="bg-white/5 rounded-lg p-3 flex items-center justify-center mb-4 border border-white/10">
                  <img
                    src="/images/qr_x.png"
                    alt="Bank Transfer QR Code"
                    className="w-40 h-40"
                  />
                </div>
                
                {/* Bank Details */}
                <div className="space-y-3 text-sm">
                  {/* Account Name */}
                  <div>
                    <p className="text-white/60 text-xs mb-2">Account Name</p>
                    <div className="flex items-center justify-between bg-white/10 rounded-lg px-4 py-3 border border-white/20">
                      <span className="font-medium text-white text-sm">{bankDetails.accountName}</span>
                      <button
                        onClick={() => handleCopy(bankDetails.accountName, 'name')}
                        className="p-1 hover:bg-white/20 rounded transition"
                      >
                        {copied === 'name' ? (
                          <Check size={16} className="text-emerald-400" />
                        ) : (
                          <Copy size={16} className="text-white/60" />
                        )}
                      </button>
                    </div>
                  </div>

                  {/* Account Number */}
                  <div>
                    <p className="text-white/60 text-xs mb-2">Account Number</p>
                    <div className="flex items-center justify-between bg-white/10 rounded-lg px-4 py-3 border border-white/20">
                      <span className="font-medium text-white text-sm">{bankDetails.accountNumber}</span>
                      <button
                        onClick={() => handleCopy(bankDetails.accountNumber, 'account')}
                        className="p-1 hover:bg-white/20 rounded transition"
                      >
                        {copied === 'account' ? (
                          <Check size={16} className="text-emerald-400" />
                        ) : (
                          <Copy size={16} className="text-white/60" />
                        )}
                      </button>
                    </div>
                  </div>

                  {/* Bank Name */}
                  <div>
                    <p className="text-white/60 text-xs mb-2">Bank Name</p>
                    <div className="flex items-center justify-between bg-white/10 rounded-lg px-4 py-3 border border-white/20">
                      <span className="font-medium text-white text-sm">{bankDetails.bankName}</span>
                      <button
                        onClick={() => handleCopy(bankDetails.bankName, 'bank')}
                        className="p-1 hover:bg-white/20 rounded transition"
                      >
                        {copied === 'bank' ? (
                          <Check size={16} className="text-emerald-400" />
                        ) : (
                          <Copy size={16} className="text-white/60" />
                        )}
                      </button>
                    </div>
                  </div>

                  {/* Swift Code */}
                  <div>
                    <p className="text-white/60 text-xs mb-2">SWIFT Code</p>
                    <div className="flex items-center justify-between bg-white/10 rounded-lg px-4 py-3 border border-white/20">
                      <span className="font-medium text-white text-sm">{bankDetails.swiftCode}</span>
                      <button
                        onClick={() => handleCopy(bankDetails.swiftCode, 'swift')}
                        className="p-1 hover:bg-white/20 rounded transition"
                      >
                        {copied === 'swift' ? (
                          <Check size={16} className="text-emerald-400" />
                        ) : (
                          <Copy size={16} className="text-white/60" />
                        )}
                      </button>
                    </div>
                  </div>

                  {/* Routing Number */}
                  <div>
                    <p className="text-white/60 text-xs mb-2">Routing Number</p>
                    <div className="flex items-center justify-between bg-white/10 rounded-lg px-4 py-3 border border-white/20">
                      <span className="font-medium text-white text-sm">{bankDetails.routingNumber}</span>
                      <button
                        onClick={() => handleCopy(bankDetails.routingNumber, 'routing')}
                        className="p-1 hover:bg-white/20 rounded transition"
                      >
                        {copied === 'routing' ? (
                          <Check size={16} className="text-emerald-400" />
                        ) : (
                          <Copy size={16} className="text-white/60" />
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Info Box */}
              <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-4">
                <p className="text-sm text-white/80">
                  ✓ All donations are secure and confidential. We provide tax receipts for all contributions.
                </p>
              </div>

              {/* Close Button */}
              <button
                onClick={onClose}
                className="w-full px-4 py-2.5 bg-white/10 text-white rounded-lg font-medium hover:bg-white/20 transition border border-white/20 backdrop-blur"
              >
                Close
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default DonationModal;